import React, { HTMLAttributes } from 'react';
import styles from './AGMessage.module.css';
import InfoIcon from 'assets/icons/infoFill.svg?react';
import CheckIcon from 'assets/icons/check.svg?react';

export type AGMessageColor = 'error' | 'success' | 'info' | 'warning';

interface AGMessageProps extends HTMLAttributes<HTMLDivElement> {
    color?: AGMessageColor;
    title?: string;
}

function AGMessage({ color = 'info', title, children, className, ...restProps }: AGMessageProps) {
    return (
        <div className={`${styles.wrapper} ${styles[color]} ${className}`} {...restProps}>
            {title && (
                <div className={styles.titleWrapper} style={children ? { marginBottom: '12px' } : {}}>
                    {color === 'success' ? <CheckIcon /> : <InfoIcon />}
                    <span className={styles.title}>{title}</span>
                </div>
            )}
            {children}
        </div>
    );
}

export default AGMessage;
